var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.$t("SettingBaseDataLovHeader.table.basicInformation"))
        ),
      ]),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataLovHeader.name"),
                prop: "lovName",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.lovName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "lovName", $$v)
                  },
                  expression: "form.lovName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c("BjFormItemCode", {
            attrs: {
              rules: _vm.rules.lovCode,
              label: _vm.$t("SettingBaseDataLovHeader.code"),
              prop: "lovCode",
            },
            model: {
              value: _vm.form.lovCode,
              callback: function ($$v) {
                _vm.$set(_vm.form, "lovCode", $$v)
              },
              expression: "form.lovCode",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }